export default {
  'Choose File': 'Seleccionar archivo',
  'Please paste a URL': 'Pega una URL',
  'Loading': 'Cargando',
  'Analyzing': 'Analizando',
  'Try a sample': 'Una prueba',
  'Sorry, error occurs when analyzing the URL.': 'Lo sentimos, se produce un error al analizar la URL.',
}